import type { DisabledInterval } from 'features/Home/interfaces/IInfoPatient'

export type DisabledCellResource = { resourceId: string; roomResourceId?: string }

// Both sides hold site wall-clock digits in browser-local Dates; compare them directly.
export const isCellDisabled = (
  cellStart: Date,
  resource: DisabledCellResource,
  disabledIntervals: DisabledInterval[],
): boolean => {
  const roomResourceId = resource.roomResourceId ?? resource.resourceId
  const time = cellStart.getTime()
  return disabledIntervals.some(
    (interval) =>
      interval.resourceId === roomResourceId &&
      interval.start.getTime() <= time &&
      time < interval.end.getTime(),
  )
}
